<template>
  <v-container class="my-0 py-0">
    <v-row justify="center">
      <v-col sm="12" md="3">
        <v-row>
          <v-col sm="12">
            <WorkOrderParameters :workid="workorder.id" />
          </v-col>
          <v-col sm="12">
            <WorkOrderAttachmentList :attachments="workorder.attachments" :id="workorder.id" />
          </v-col>
        </v-row>
      </v-col>
      <v-col sm="12" md="7">
        <v-row>
          <v-col sm="12">
            <v-card>
              <v-card-title>
                <v-icon left>fas fa-clipboard</v-icon>
                Work Order Summary
                <v-spacer />
                <v-btn text :to="{ name: 'WorkOrderSummaryEditView', params: { id: id, workid: workid } }">
                  EDIT
                </v-btn>
              </v-card-title>
              <v-divider />
              <BaseRichTextDisplay :content="workorder.richtext" />
            </v-card>
          </v-col>
          <v-col sm="12" md="6">
            <ToolProcessHistory :processes="processes" :is-tool-view="false" />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import BaseRichTextDisplay from "../../components/Base/BaseRichTextDisplay";
import WorkOrder from "../../models/WorkOrder";
import WorkOrderParameters from "../../components/WorkOrders/WorkOrderParameters";
import WorkOrderAttachmentList from "../../components/WorkOrders/WorkOrderAttachmentList";
import ToolProcess from "../../models/ToolProcess";
import ToolProcessHistory from "../../components/Systems/ToolProcessHistory";
export default {
  name: "WorkOrderSummaryView",
  components: {
    ToolProcessHistory,
    WorkOrderAttachmentList,
    WorkOrderParameters,
    BaseRichTextDisplay
  },
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
    workid: {
      type: [Number, String],
      required: true
    }
  },
  computed: {
    workorder() {
      return WorkOrder.query()
        .with("attachments")
        .find(parseInt(this.workid))
    },
    processes() {
      return ToolProcess.query()
        .where("workorder_id", parseInt(this.workid))
        .with("tool")
        .with("workorder")
        .get()
    }
  }
}
</script>
